import './reviews-slider.scss';
import GLightbox from 'glightbox';
import Swiper from 'swiper/swiper-bundle';

export default () => {
	new Swiper( '.js-review-slider', {
		effect: 'cards',
		grabCursor: true,
		loop: true,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );

	GLightbox( {
		selector: '.glightbox2',
		closeOnOutsideClick: false,
		touchNavigation: true,

	} );
};
